import "@/sentry/instrument"; // must be first — initialises Sentry before any app code
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { AppErrorBoundary } from "@/sentry/ErrorBoundary";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
